import {inject, Injectable} from "@angular/core";
import {HttpErrorResponse} from "@angular/common/http";
import {WrapperDto} from "../../repositories/dto/wrapper.dto";
import {isDefined} from "../../libs/utils/epic.utils";
import {ValidationErrorDto} from "../../repositories/dto/validation-error.dto";
import {ExceptionErrorDto} from "../../repositories/dto/exception-error.dto";
import {LoggingService} from "../logger/logging.service";
import {AccError, AccErrorWrapper} from "./acc-error";

@Injectable({providedIn: 'root'})
export class ErrorHelper {

  private readonly log: LoggingService = inject(LoggingService);

  public parse(ex: HttpErrorResponse | WrapperDto<any>): AccErrorWrapper {
    const errors: AccError[] = [];
    const err: any = ex instanceof HttpErrorResponse ? ex.error : ex;
    if (isDefined(err) && isDefined(err.dataType)) {
      if (err.dataType === 'ValidationErrorDto') {
        errors.push(...this.parseValidationError(new WrapperDto<ValidationErrorDto>(err)));
      } else if (err.dataType === 'ExceptionErrorDto') {
        errors.push(...this.parseExceptionError(new WrapperDto<ExceptionErrorDto>(err)));
      } else {
        this.log.error('Unhandled Acc error datatype "{}"', [err.dataType]);
      }
    } else if (ex instanceof HttpErrorResponse) {
      errors.push(...this.parseHttpError(ex));
    } else {
      this.log.error('Unhandled http error type "{}"', [ex]);
    }
    return new AccErrorWrapper({errors});
  }

  private parseValidationError(wrapperDto: WrapperDto<ValidationErrorDto>): AccError[] {
    return wrapperDto.getErrors().map(v => new AccError({
      messageCode: v.messageCode,
      code: v.errorCode,
      field: v.field,
    }));
  }

  private parseExceptionError(wrapperDto: WrapperDto<ExceptionErrorDto>): AccError[] {
    return wrapperDto.getErrors().map(v => new AccError({
      messageCode: v.message,
      code: v.code
    }));
  }

  private parseHttpError(ex: HttpErrorResponse): AccError[] {
    const msg = (ex.status ? ex.status + ' - ' : '') + ex.message;
    switch (ex.status) {
      case 0:
        return [new AccError({code: '90000', messageCode: 'error.0', message: msg})];
      case 404:
        return [new AccError({code: '90404', messageCode: 'exception.notFound', message: msg})];
      case 500:
        return [new AccError({code: '90500', messageCode: 'error.500', message: msg})];
      default: {
        this.log.warn('Unhandled http error code "{}" - fallback to unknown', [ex.status]);
        const code: string = '90' + (ex.status ? ex.status : '000');
        return [new AccError({code: code, messageCode: 'exception.unknown', message: msg})];
      }
    }
  }
}
